var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDudeYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    className: "dude-yellow-image",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB133",
    d: "M0 0h120L60 60v60H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.272 81.906h34.283v11.428H41.272z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.073 61.01L49.315 85.25l-8.081 8.081L16.992 69.09zM44.444 13.333h26.667V40H44.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M44.444 31.111V13.333h17.778z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.889 13.333h26.667V40H8.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.889 31.111V13.333h17.778z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDudeYellow);
export default __webpack_public_path__ + "static/media/dude-yellow.3798a96f.svg";
export { ForwardRef as ReactComponent };